import React, { useState, useEffect, useRef } from 'react'
import {Grid , Box} from '@mui/material';
import { Typography } from '@mui/material';
import sarvban from "../../images/sarvban.jpg"
import kavoshgaran from "../../images/kavoshgaran.jpg"
import sirang from "../../images/sirang.jpg"
import Avatar from '@mui/material/Avatar';
import { makeStyles } from '@mui/styles'
import sarvbanLogo from "../../images/sarvbanLogo.png"
import kavoshgaranLogo from "../../images/kavoshgaranLogo.jpg"
import sirangLogo from "../../images/sirangLogo.jpg"



const useStyles = makeStyles({
    root : {
        paddingLeft : "10%" , 
        paddingRight : "10%" , 
        marginTop : "4%"
    },
    container: {
        display: "flex",
        alignItems: "center",
        marginBottom : "5%"
      },
      LeftBorder: {
        borderBottom: "2px solid lightgray",
        width : "70%" ,
        marginRight : "5%"
      },
      RightBorder: {
        borderBottom: "2px solid lightgray",
        width : "70%" ,
        marginLeft : "5%" ,
      },
      content: {
        paddingTop: "4px",
        paddingBottom: "4px",
        paddingRight: "80px",
        paddingLeft: "80px",
        fontWeight: 500,
        fontSize: 30,
        color: "lightgray" , 
        width : "40%" ,
        textAlign : "center" ,
        fontFamily : "Vazir"
      } ,
      imageBox : {
        position : "relative" , 
        width : "100%" , 
        height : "200px"
      } ,
      image : {
        position : "absolute" , 
        top: 0 , 
        left : 0 , 
        width : "100%" , 
        height : "100%"
      } ,
});

export default function CollaborationTeam() {

    const classes = useStyles();

    const [maxHeight, setMaxHeight] = useState()

    const [width, setWidth] = useState(0)

    const sarvbanBox = useRef(null)

    const kavoshgaranBox = useRef(null)

    const sirangBox = useRef(null)

    useEffect(() => {
      // setHeight(ref.current.clientHeight)
      console.log("sarvbanBox.current.clientHeight" , sarvbanBox?.current?.clientHeight);
      console.log("kavoshgaranBox.current.clientHeight" , kavoshgaranBox?.current?.clientHeight);
      console.log("sirangBox.current.clientHeight" , sirangBox?.current?.clientHeight);
      if(sarvbanBox?.current?.clientHeight && kavoshgaranBox?.current?.clientHeight && sirangBox?.current?.clientHeight){
        setMaxHeight(Math.max(sarvbanBox?.current?.clientHeight, kavoshgaranBox?.current?.clientHeight , sirangBox?.current?.clientHeight))
      }
      if(sarvbanBox?.current?.clientWidth){
        setWidth(sarvbanBox?.current?.clientWidth)
      }

    },[sarvbanBox?.current , kavoshgaranBox?.current , sirangBox?.current])
console.log("maxHeight" , maxHeight);

    const avatarStyle = {
        width: width * 0.4, 
        height: width * 0.4 , 
        position : "absolute" , 
        bottom : `-${width*0.2}px`, 
        left : `${(width - width*0.4)/2}px`
    } 

    const typographyStyles = {
      aboutTeam : {
        marginTop : "80px" , 
        direction : "rtl" , 
        padding : "16px" , 
        textAlign : "justify" , 
        color : "gray" , 
        fontFamily : "Vazir" ,
        fontSize : "14px" ,
        // fontWeight : 300 ,
        lineHeight : "24px"
      }
    }

    const boxesStyle = {
      boxShadow: "rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px" , 
      borderRadius : "4px" , 
      marginLeft : "12px" , 
      marginRight : "12px" , 
      height : `${maxHeight + 50}px`
    } 

    return (
        <div className={classes.root}>
            <div className={classes.container}>
                <div className={classes.LeftBorder} />
                <span className={classes.content}>شبکه همکاران</span>
                <div className={classes.RightBorder} />
            </div>
            <Grid container style={{direction : "rtl"}}>
                <Grid itme xl={4} lg={4} md={4} sm={4} xs={4} >
                    <Box sx={boxesStyle} ref={sarvbanBox} >
                        <Box className={classes.imageBox}>
                            <img src={sarvban} className={classes.image}/>
                            <Avatar src={sarvbanLogo} sx={avatarStyle}/>
                        </Box>
                        <Typography sx={typographyStyles.aboutTeam}>سروبان کشاورز را به بازار متصل می‌کند و به او قدرت انتخاب بیشتری می‌دهد که محصولش را به چه کسی و با چه قیمتی بفروشد.از طرف دیگر در سمت بازار نیز پیدا کردن محصول سخت است و سروبان با ایجاد دسترسی به کشاورزان به خریداران کمک می‌کند که محصول مورد نظر خود را با کیفیت و قیمت مناسبی خریداری کنند
سروبان برای کشاورزان و محصولاتشان سه خدمت اصلی بازاریابی، بازارسازی و بازاررسانی انجام می دهد و پل ارتباطی مستقیم بین کشاورز و بازار است. به این ترتیب در این پلتفرم با فروش تخصصی محصول و ایجاد مسیر دسترسی مناسب بین تولیدکننده تا خریدار، کشاورز درآمد بیشتری خواهد داشت و خریدار نیز با مزایای بیشتری خرید می کند.</Typography>
                    </Box>
                </Grid>
                <Grid itme xl={4} lg={4} md={4} sm={4} xs={4} >
                    <Box sx={boxesStyle} ref={kavoshgaranBox} >
                        <Box className={classes.imageBox}>
                            <img src={kavoshgaran} className={classes.image}/>
                            <Avatar src={kavoshgaranLogo} sx={avatarStyle}/>
                        </Box>
                        <Typography sx={typographyStyles.aboutTeam}>گروه مهندسين شرکت دانش بنیان کاوشگران آب متشکل از جمعي از نخبگان، فارغ التحصيلان برتر دانشگاههاي معتبر کشور، که داراي سوابق مختلف مشاوره ای و اجرايي در حوزه آبيابي و ژئوفيزيک و استفاده از ماهواره در مديريت منابع آب و همچنین مهندسي معکوس در مطالعات آب وهواشناسی کشاورزی مي باشند.
                        اين مجموعه با استفاده از دانش علمي و آکادميک و همچنين تجربيات و تجهیزات مدرن قادر به ارائه ایستگاه هوشمند آب و هواشناسی کشاورزی برای هوشمند سازی باغات کشاورزان و نهادهای مختلف می باشد.</Typography>
                    </Box>
                </Grid>
                <Grid itme xl={4} lg={4} md={4} sm={4} xs={4} >
                    <Box sx={boxesStyle} ref={sirangBox}>
                        <Box className={classes.imageBox}>
                            <img src={sirang} className={classes.image}/>
                            <Avatar src={sirangLogo} sx={avatarStyle}/>
                        </Box>
                        <Typography sx={typographyStyles.aboutTeam}>پهپاد سیرنگ، یکی از پهپادهای پیشرفته و نوآورانه در حوزه کشاورزی است که با استفاده از تکنولوژی‌های پیشرفته، بهبودی چشمگیر در عملکرد کشاورزی ایجاد می‌کند. این پهپاد با قابلیت هوش مصنوعی و سیستم‌های دقیق مکان‌یابی، قادر به انجام وظایف متعددی از جمله سمپاشی، آبیاری، مانیتورینگ محصولات و تجزیه و تحلیل وضعیت مزرعه‌ها می‌باشد. از ویژگی‌های برجسته سیرنگ می‌توان به دقت بالا در اجرای عملیات کشاورزی، کاهش مصرف منابع آب و مواد شیمیایی، افزایش بهره‌وری و بهبود کیفیت محصولات اشاره کرد. به این ترتیب، پهپاد به عنوان یک ابزار بسیار موثر و متناسب با فناوری‌های کشاورزی نوین، در جهت پیشبرد کشاورزی هوشمند و پایدار ایفای نقش حیاتی می‌نماید.</Typography>
                    </Box>
                </Grid>
            </Grid>
        </div>
    )
}